import { render, staticRenderFns } from "./IndiamartV2.vue?vue&type=template&id=97875e50&scoped=true"
import script from "./IndiamartV2.vue?vue&type=script&lang=js"
export * from "./IndiamartV2.vue?vue&type=script&lang=js"
import style0 from "./IndiamartV2.vue?vue&type=style&index=0&id=97875e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97875e50",
  null
  
)

export default component.exports